/** Les montants circulent en centimes. On ne formate qu'a l'affichage. */
export const centimes = (majeur: number): number => Math.round(majeur * 100);

export function montant(minor: number | undefined | null, devise = 'DZD', decimales = 2): string {
  const v = minor ?? 0;
  const neg = v < 0;
  const s = Math.abs(v).toString().padStart(decimales + 1, '0');
  const ent = s.slice(0, s.length - decimales) || '0';
  const dec = s.slice(s.length - decimales);
  return `${neg ? '−' : ''}${ent.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')},${dec} ${devise}`;
}

/** Version compacte pour les graphiques et les cellules serrees. */
export function montantCourt(minor: number | undefined | null, devise = 'DZD'): string {
  const v = Math.round((minor ?? 0) / 100);
  if (Math.abs(v) >= 1_000_000) return `${(v / 1_000_000).toFixed(1).replace('.', ',')} M ${devise}`;
  if (Math.abs(v) >= 10_000) return `${Math.round(v / 1000)} k ${devise}`;
  return `${v.toLocaleString('fr-FR').replace(/ /g, ' ')} ${devise}`;
}

const d2 = (n: number) => String(n).padStart(2, '0');
export const dateFr = (d: string | Date | undefined | null): string => {
  if (!d) return '—';
  const x = new Date(d);
  return `${d2(x.getDate())}/${d2(x.getMonth() + 1)}/${x.getFullYear()}`;
};
export const heureFr = (d: string | Date | undefined | null): string => {
  if (!d) return '—';
  const x = new Date(d);
  return `${d2(x.getHours())}h${d2(x.getMinutes())}`;
};
export const dateHeureFr = (d: string | Date | undefined | null): string =>
  d ? `${dateFr(d)} · ${heureFr(d)}` : '—';
export const plageFr = (a: string | Date, b: string | Date): string => {
  const x = new Date(a), y = new Date(b);
  return `${d2(x.getDate())}/${d2(x.getMonth() + 1)} → ${dateFr(y)}`;
};
export const isoJour = (d: Date): string => `${d.getFullYear()}-${d2(d.getMonth() + 1)}-${d2(d.getDate())}`;
export const ajouteJours = (d: Date, n: number): Date => new Date(d.getTime() + n * 86400000);

export const JOURS = ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'];

export const STATUT_LABEL: Record<string, string> = {
  option: 'Option', confirmee: 'Confirmée', en_cours: 'En cours', terminee: 'Terminée',
  annulee: 'Annulée', non_restitue: 'Non restitué',
  disponible: 'Disponible', loue: 'Louée', entretien: 'Entretien', immobilise: 'Immobilisée', vendu: 'Vendue',
  detenue: 'Détenue', restituee: 'Restituée', retenue_partielle: 'Retenue partielle', saisie: 'Saisie',
  brouillon: 'Brouillon', actif: 'Actif', clos: 'Clos', resilie: 'Résilié',
  en_attente: 'En attente', accordee: 'Accordée', refusee: 'Refusée',
  non_declare: 'Non déclaré', declare: 'Déclaré', expertise: 'Expertise',
  accepte: 'Accepté', refuse: 'Refusé', rembourse: 'Remboursé',
}

/** Le role vit en base sous forme de cle technique ; l'ecran ne montre jamais la cle. */
export const ROLE_LABEL: Record<string, string> = {
  gerant_finances: 'Gérant · finances',
  gerant: 'Gérant',
  agent: 'Agent',
};
export const roleLabel = (r: string): string => ROLE_LABEL[r] ?? r.replace(/_/g, ' ');

export const COUVERTURE_LABEL: Record<string, string> = {
  tous_risques: 'Tous risques', tiers_plus: 'Tiers plus', tiers: 'Au tiers',
};
export const SOURCE_KM_LABEL: Record<string, string> = {
  saisie: 'Saisie directe', etat_des_lieux: 'État des lieux', entretien: 'Entretien',
};

export const CARBURANT_LABEL = ['vide', '1/4', '1/2', '3/4', 'P'];

export const nomClient = (c: { nom?: string; prenom?: string; raisonSociale?: string } | null | undefined): string =>
  !c ? '—' : c.raisonSociale || [c.prenom, c.nom].filter(Boolean).join(' ') || '—';
